import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { taskService } from '../features/task/services/taskService';
import { firebaseNotificationService } from '../Firebase';

const TaskListContext = createContext();

export const useTaskListContext = () => {
  const context = useContext(TaskListContext);
  if (!context) {
    throw new Error('useTaskListContext must be used within a TaskListProvider');
  }
  return context;
};

export const TaskListProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [taskListData, setTaskListData] = useState([]);

  const fetchTaskList = useCallback(async (page = 1, filters = {}, showLoader = true) => {
    try {
      if (showLoader) {
        setIsLoading(true);
      }
      const response = await taskService.fetchMaintenanceRequests(page, filters);
      
      if (response.success) {
        setTaskListData(response.data);
        return response;
      }
      return null;
    } catch (error) {
      console.error('Error fetching task list:', error);
      return null;
    } finally {
      if (showLoader) {
        setIsLoading(false);
      }
    }
  }, []);

  // Register the fetchTaskList function with Firebase service
  useEffect(() => {
    firebaseNotificationService.setFetchTaskListCallback(fetchTaskList);
    
    return () => {
      firebaseNotificationService.setFetchTaskListCallback(null);
    };
  }, []);

  const value = {
    isLoading,
    taskListData,
    fetchTaskList,
    setTaskListData
  };

  return (
    <TaskListContext.Provider value={value}>
      {children}
    </TaskListContext.Provider>
  );
};